import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutral: true;
  }
}

export const MuiButton: Components<Theme>['MuiButton'] = {
  defaultProps: {
    variant: 'contained',
    disableElevation: true,
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      borderRadius: 4,
      textTransform: 'none',
      ...theme.typography.label1,
      ...(ownerState.size === 'medium' && {
        padding: '0.625rem 1.5rem',
      }),
    }),
  },
};
